import { lettersList } from "constants/superAdmin";

const initialState = {
  lettersList: {},
};

const superAdmin = (state = initialState, action) => {
  switch (action.type) {
    case lettersList:
      return { ...state, lettersList: action.payload };

    default:
      return state;
  }
};

export default superAdmin;
